import styled from 'styled-components'

interface SizeProps {
  fontSize: string
}

export const Container = styled.div`
div:first-child{
    display: flex;
}
`

export const CircleDiv = styled.div`
display: flex;
flex-direction: column;
align-items: center;
hr{
    height: 100%;
    width: .5rem;
    background: var(--terc6);
    border: none;
}
`

export const CardDiv = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    border-radius:2.5rem;
    background: #${props => props.theme};
    box-shadow: var(--SombraBackground);
    color: white;
    cursor: pointer;
    min-height: 80px;
    padding-left: 2em;
    padding-right: 2rem;

    &:hover{
        box-shadow: var(--SombraBtns);
        filter: brightness(.9);
    }
`

export const BackgroundCard = styled.div<{ isOpen?: boolean }>`
    display: flex;
    flex-direction: column;
    background:#${props => props.theme};
    border-radius: 2.5rem;
    margin-bottom: 2rem;
    overflow-y: hidden;
    border-bottom-left-radius: 2.5rem;
    border-bottom-right-radius: 2.5rem;
    transition: max-height .7s;
    max-height:80px;

    ${({ isOpen }) => isOpen && `
        border-bottom-left-radius: 2rem;
        border-bottom-right-radius: 2rem;
        transition: max-height 1.2s;
        max-height: 100rem;
    `}
`

export const BodyCard = styled.div<{ isOpen?: boolean }>`
    display: flex;
    flex-direction: column;
    padding: 1.5rem 2rem 2rem 2rem;
    pointer-events: none;

    ${({ isOpen }) => isOpen && `
        pointer-events: unset;
    `}
`

export const CircleCard = styled.div<SizeProps>`
background: var(--c1);
color: var(--a3);
border: solid var(--terc6);
border-width: 0.3rem;
box-sizing: border-box;
min-height: 5rem;
width: 5rem;
border-radius: 2.5rem;
display: flex;
justify-content:center ;
text-align: center;
align-items: center;
font-family: 'Poppins';
font-size: ${props => props.fontSize}rem;
font-weight: 800;
`

export const FlexElipse = styled.div`
display: flex;
height: 5.313rem;
align-items: center;
margin-left: .5rem;

div{
    margin-right:.3rem;
}

div:nth-child(1){
    height: 0.5rem;
    width: 0.5rem;
    background: var(--c4);
    border-radius: .5rem;
}

div:nth-child(2){
    height: 0.625rem;
    width: 0.625rem;
    background: var(--c6);
    border-radius: 0.625rem;
}

div:nth-child(3){
    height: .75rem;
    width: .75rem;
    background:#${props => props.color};
    border-radius: .75rem;
}
`

export const EditMenu = styled.div<{isOpen?: boolean}>`
display: flex;
position: relative;
left: -5rem;
transition: all 0.9s ease;
opacity: 0%;
position: relative;
pointer-events:none;
margin-left:.5rem;

${({ isOpen }) => isOpen && `
       pointer-events:unset ;
       left: 0rem;
       opacity: 100%;
    `}

svg{
    margin-left: 0rem!important;
}

a{
    justify-content: center;
    align-items: center;
    height: fit-content;
    margin-right: 1rem;
    height: 2.5rem;
    width: 2.5rem;
    display: flex;
    border-radius: 2.5rem;
    cursor: pointer;
    position: relative;
    top: 1rem;
}

a:nth-child(1){
    border: 2px solid var(--a1);
    color: var(--a1);

    &:hover{
        background: var(--a1);
        color: white;
    }
}

a:nth-child(2){
    border: 2px solid var(--terc1);
    color: var(--terc1);

    &:hover{
        background: var(--terc1);
        color: white;
    }
}
`
